// extracted by mini-css-extract-plugin
module.exports = {"root":"container-module--root--3lQwK","dark":"container-module--dark--2laYW","narrow":"container-module--narrow--1zL7b","narrower":"container-module--narrower--1ZCW_"};